import ThankYouModal from './thank-you';

export default ThankYouModal;
